<template>
    <div class="tw-hidden">
        <button
            type="button"
            class="cu-btn-default-sm btn-enable-use-full-screen"
            @click="toggleFullscreen(true)"
        >
            <i class="fa fa-window-maximize"></i> Vollbild
        </button>

        <button
            type="button"
            class="cu-btn-default-sm btn-disnable-use-full-screen"
            @click="toggleFullscreen(false)"
        >
            <i class="fa fa-window-minimize"></i> Vollbild schließen
        </button>
    </div>
</template>

<script>
export default {
    methods: {
        toggleFullscreen(useFullscreen) {
            if (useFullscreen) {
                Cookies.set('FullScreenView', 'enabled');
                $('#app-layout').attr('data-use-full-screen', 1);
            } else {
                Cookies.set('FullScreenView', 'disabled');
                $('#app-layout').attr('data-use-full-screen', 0);
            }
        }
    }
}
</script>

